module.exports = {
          srcSet: __webpack_public_path__ + "79bd970456cd5868e88a656712f03eae-60.png"+" 60w",
          images:[ {path: __webpack_public_path__ + "79bd970456cd5868e88a656712f03eae-60.png",width: 60,height: 60}],
          src: __webpack_public_path__ + "79bd970456cd5868e88a656712f03eae-60.png",
          toString:function(){return __webpack_public_path__ + "79bd970456cd5868e88a656712f03eae-60.png"},
          
          width: 60,
          height: 60
        }